import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"
import { AxiosResponse } from "axios"

import store from "store"

import { ID, intboolean, ReduxList } from "app/types/app-types"
import { FiltersFormType, emptyFiltersState } from "../types/filtertypes"

import {
    Icon,
    Theme,
    Spinner,
    Message,
    Grid,
    GridCell,
    LittleStatus,
    TableGrid,
    TRow,
    TCell,
    css,
    Checkbox,
    Popup,
    Button,
} from "@bdfx/mergado-ui-kit"

import {
    eshopId,
    projectId,
    toggleActiveFIEQuery,
    deleteFIEQuery,
    getAllFIEQueries,
} from "app/helpers/api";

import { ViewTableType } from "../containers";
import ParseFiltersForm from "./parse-filters-form";
import { getIconByViewTable } from "app/helpers/other";
import { iconDisabledColor } from "template-edit/components/tools-panel";
import { setActiveFIEQueryId, setFIEQueriesToStore } from "../reducer";
import Mergado from "app/helpers/mergado";
import { createToast } from "actions";
import { textToast } from "app/helpers/toast_factory";
import { RouterType, withRouter } from "app/components/routes";
import { removeEmpty } from "shape-edit/forms/helpers";
import CreatePredefinedQueries from "./create-predefined-queries";
import { Query } from "app/types/model-types"
import { initForm } from "app/reducers/form"
import { find } from "lodash"

export type FIEQueryType = {
    id?: ID
    is_active: intboolean
    project_id: ID
    name: string
    filter: string  //JSON encoded
    element: string
    viewtable: ViewTableType
    mergado_query_id?: ID
    created_at?: string
    updated_at?: string
}

interface Props {
    router: RouterType
    initForm: typeof initForm
    setViewTable: Function
    setActiveFIEQueryId: typeof setActiveFIEQueryId
    setFIEQueriesToStore: typeof setFIEQueriesToStore
    activeFIEQueryId: ID
    fieQueries: ReduxList<FIEQueryType[]>
    filterNow: Function
}

interface State {
    selectedRows: ID[]
    isUpdating: boolean
}

class FieQueries extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            selectedRows: [],
            isUpdating: false,
        }
    }

    componentDidMount() {
        getAllFIEQueries()
            .then((response: AxiosResponse<FIEQueryType[]>) => {
                this.props.setFIEQueriesToStore(response.data)
            })
        .catch((e) => console.error('cannot get fie queries', e))
    }

    handleDeleteQuery = (fieQueryId: ID) => {
        this.setState({ isUpdating: true })
        deleteFIEQuery(fieQueryId)
            .then((response: AxiosResponse<FIEQueryType[]>) => {
                this.props.setFIEQueriesToStore(response.data)
            })
            .catch(error => {
                if (error.response && error.response.status === 409 && error.response.data.error) {
                    const message = `${trans(error.response.data.error)} (${error.response.data.template_ids.join(',')})`
                    store.dispatch(createToast(textToast('error', message)))
                } else {
                    console.error('cannot delete fie query', error)
                }
            })
            .finally(() => {
                this.setState({ isUpdating: false })
            })
    }

    handleEdit = (fieQueryId) => {
        this.props.setActiveFIEQueryId(fieQueryId)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    handleShowProducts = (fieQuery) => {
        const filter: FiltersFormType = JSON.parse(fieQuery.filter)

        this.props.initForm('filtersForm', {
            ...emptyFiltersState,
            ...removeEmpty(filter)
        })

        if (fieQuery.viewtable) {
            this.props.setViewTable(fieQuery.viewtable)
            this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/products/${fieQuery.viewtable}`)
        } else if (filter.watermark && ((Array.isArray(filter.watermark.status) && filter.watermark.status.length > 0) || filter.watermark.user_set !== "")) {
            this.props.setViewTable('watermarks')
            this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/products/watermarks`)
        } else if (filter.image_validations && ((Array.isArray(filter.image_validations.status) && filter.image_validations.status.length > 0) || filter.image_validations.mistake_set_by_user !== null)) {
            this.props.setViewTable('validations')
            this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/products/validations`)
        } else if (filter.quality && ((Array.isArray(filter.quality.status) && filter.quality.status.length > 0) || filter.quality.user_set !== '')) {
            this.props.setViewTable('images_quality')
            this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/products/images_quality`)
        } else {
            this.props.setViewTable('products')
            this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/products/products`)
        }

        this.props.filterNow()
    }

    toggleRow = (fieQueryId: ID) => {
        const { selectedRows } = this.state

        let updatedRows = []
        if (selectedRows.includes(fieQueryId)) {
            selectedRows.forEach(rowId => {
                if (rowId !== fieQueryId) {
                    updatedRows.push()
                }
            })
        } else {
            updatedRows = [...selectedRows, fieQueryId]
        }
        this.setState({ selectedRows: updatedRows })
    }

    toggleAll = () => {
        const { selectedRows } = this.state
        const { fieQueries } = this.props

        const allRows = fieQueries.data.map(fieQuery => fieQuery.id)

        if (selectedRows.length > 0 && selectedRows.length === fieQueries.data.length) {
            this.setState({ selectedRows: [] })
        } else {
            this.setState({ selectedRows: allRows })
        }
    }

    handleToggleActive = (fieQueryId: ID) => {
        this.setState({ isUpdating: true })
        toggleActiveFIEQuery(fieQueryId)
            .then((response: AxiosResponse<FIEQueryType[]>) => {
                this.props.setFIEQueriesToStore(response.data)
            })
            .catch(error => {
                if (error.response && error.response.status === 409 && error.response.data.error) {
                    const message = `${trans(error.response.data.error)} (${error.response.data.template_ids.join(',')})`
                    store.dispatch(createToast(textToast('error', message)))
                } else {
                    console.error('cannot toggle active fie query', error)
                }
            })
            .finally(() => {
                this.setState({ isUpdating: false })
            })
    }

    handleBulkAction = (type: "delete" | "toggle_active" | "toggle_inactive") => {
        const { selectedRows } = this.state

        selectedRows.forEach(rowId => {
            const fieQuery: FIEQueryType = find(this.props.fieQueries.data, (fieQuery) => {
                return fieQuery.id === rowId
            })
            switch (type) {
                case "delete":
                    this.handleDeleteQuery(rowId)
                    break
                case "toggle_active":
                    if (fieQuery && !fieQuery.is_active) {
                        this.handleToggleActive(rowId)
                    }
                    break
                case "toggle_inactive":
                    if (fieQuery && fieQuery.is_active) {
                        this.handleToggleActive(rowId)
                    }
                    break
            }

            this.toggleRow(rowId)
        })
    }

    close = () => {
        this.props.setActiveFIEQueryId(null)
    }

    render() {
        const { fieQueries } = this.props
        const { selectedRows, isUpdating } = this.state

        const iconSize = 18

        if (!fieQueries.isLoaded) {
            return <Spinner type={'bubbles'} />
        }

        //find active:
        const activeQuery = this.props.activeFIEQueryId && this.props.fieQueries.isLoaded ? find(this.props.fieQueries.data, (fieQuery) => {
            return fieQuery.id === this.props.activeFIEQueryId
        }) : null

        const hash = fieQueries.data && fieQueries.data.length > 0 ? fieQueries.data.map(fieQuery => `${fieQuery.id}_${fieQuery.is_active ? 'a' : 'i'}`).join('-') : ''

        return (
            <div>
                {activeQuery && activeQuery.filter &&
                    <EditActiveQueryDiv className={'shadow-box'}>
                        <div style={{ textAlign: 'right' }}>
                            <span className={'clickable'} onClick={() => this.close()}>
                                <Icon type={'close'} size={22} color={Theme.grey} />
                            </span>
                        </div>
                        <ParseFiltersForm fieQuery={activeQuery} isEditMode={true} closeModal={this.close} />
                    </EditActiveQueryDiv>
                }

                {fieQueries.data && fieQueries.data.length > 0 &&
                    <StyledTable
                        key={`table_${selectedRows.join(',')}${isUpdating ? 't' : 'f'}${hash}`}
                        actions={
                            <Grid className="actions" cols={`${selectedRows.length > 0 ? "auto" : ""} 1fr auto auto auto auto`} gap="10px" valign="center">
                                <div style={{ height: '32px' }}>
                                    {selectedRows.length > 0 &&
                                        <Popup
                                            onOpenAutoFocus={e => e.preventDefault()}
                                            side="bottom" icon={<Button icon={<Icon type="chevron-down-light" size={15} text={trans("selected") + " ..."} />} size="small" />}>
                                            <Grid gap="5px">
                                                <Button onClick={evt => this.handleBulkAction("delete")} style={{ textAlign: "left", width: "100%" }} simple={true} icon="trash-radix">{trans("delete")}</Button>
                                                <Button onClick={evt => this.handleBulkAction("toggle_active")} style={{ textAlign: "left", width: "100%" }} simple={true} icon="play-radix">{trans("active")}</Button>
                                                <Button onClick={evt => this.handleBulkAction("toggle_inactive")} style={{ textAlign: "left", width: "100%" }} simple={true} icon="pause-radix">{trans("inactive")}</Button>
                                            </Grid>
                                        </Popup>
                                    }
                                </div>
                            </Grid>}
                        header={
                            [
                            <Checkbox
                                small={true}
                                checked={selectedRows.length === fieQueries.data.length}
                                style={{ margin: "-15px 0", position: "relative", top: "10px" }}
                                onChange={() => this.toggleAll()}
                            />,
                            trans('fie_query_is_active'),
                            trans('fie_query_name'),
                            trans('fie_query_type'),
                            trans('fie_query_filter'),
                            trans('action')
                            ].map((item, i: number) => {
                                const key = `header_${i}`
                                return <React.Fragment key={key}>
                                    <TCell
                                        align="left"
                                        width={i === 0 ? "40px" : "auto"}
                                        style={{
                                            background: "#fbfbfb !important",
                                            position: "sticky",
                                            zIndex: 2,
                                            left: 0,
                                            clipPath: "polygon(0 0%, 150% 0%,150% 150%,0% 150%)",
                                            boxShadow: "1px 0px 3px rgba(0,0,0,0.08)"
                                        }}>{item}</TCell>
                                </React.Fragment>
                            })
                        }
                        className={isUpdating ? 'muk-helper-loading' : ''}
                    >
                        {fieQueries.data.map((fieQuery: FIEQueryType) => {
                            return <React.Fragment key={`fie_query_${fieQuery.id}`}>
                                <TCell width={"40px"}>
                                    <Checkbox
                                        style={{ display: "inline-block" }}
                                        checked={selectedRows.includes(fieQuery.id)}
                                        onChange={() => this.toggleRow(fieQuery.id)}
                                    />
                                </TCell>
                                <TCell width={"auto"}>
                                    <LittleStatus
                                        type={fieQuery.is_active ? 'success' : 'warning'}
                                        text={fieQuery.is_active ? trans('is_active') : trans('not_active')}
                                    />
                                </TCell>
                                <TCell width={"auto"}>
                                    <div title={trans('edit')} style={{ fontWeight: 'bold' }} className={'clickable'} onClick={() => this.handleEdit(fieQuery.id)}>
                                        {fieQuery.name}
                                    </div>
                                    <div style={{ fontSize: '10px', color: '#3a3a3a' }}>
                                        <code title={trans('edit')}>{fieQuery.element}</code>
                                    </div>
                                </TCell>
                                <TCell width={"auto"}>
                                    <div
                                        title={trans('show_products')}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.handleShowProducts(fieQuery)}>
                                        <Icon type={getIconByViewTable(fieQuery.viewtable)} size={iconSize} text={trans(fieQuery.viewtable)} color={iconDisabledColor} />
                                    </div>
                                </TCell>
                                <TCell width={"auto"}>
                                    <div
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.handleEdit(fieQuery.id)}
                                        title={trans('edit')}
                                        className={this.props.activeFIEQueryId === fieQuery.id ? 'shadow-box' : ''}>
                                        <ParseFiltersForm fieQuery={fieQuery} isEditMode={false} />
                                    </div>
                                </TCell>
                                <TCell width={"auto"} style={{ whiteSpace: 'nowrap' }}>
                                    <ButtonsGrid cols={'repeat(5, max-content)'} gap={10}>
                                        <GridCell>
                                            <span title={trans('edit')} onClick={() => this.handleEdit(fieQuery.id)}>
                                                <Icon type={'pencil'} size={iconSize} color={Theme.blue} />
                                            </span>
                                        </GridCell>
                                        <GridCell>
                                            <span title={trans('toggle_active')} onClick={() => this.handleToggleActive(fieQuery.id)}>
                                                <Icon type={fieQuery.is_active ? 'pause' : 'play'} size={iconSize} color={Theme.blue} />
                                            </span>
                                        </GridCell>
                                        <GridCell>
                                            <span title={trans('delete')} onClick={() => this.handleDeleteQuery(fieQuery.id)}>
                                                <Icon type={'trash'} size={iconSize} color={Theme.red} />
                                            </span>
                                        </GridCell>
                                        <GridCell>
                                            <span title={trans('show_products')} onClick={() => this.handleShowProducts(fieQuery)}>
                                                <Icon type={'cube'} size={iconSize} />
                                            </span>
                                        </GridCell>
                                        {fieQuery.mergado_query_id &&
                                            <GridCell>
                                                <span title={trans('show_in_mergado')} onClick={() => Mergado.openWindow(`https://app.mergado.com/projects/${projectId}/queries/edit/${fieQuery.mergado_query_id}`)}>
                                                    <Icon type={'mergado'} size={iconSize} />
                                                </span>
                                            </GridCell>
                                        }
                                    </ButtonsGrid>
                                </TCell>
                            </React.Fragment>
                        })}
                    </StyledTable>
                }

                {fieQueries.isLoaded && fieQueries.data && fieQueries.data.length === 0 &&
                    <Message type={"info"} closeable={true} icon={<Icon type={'info'} color={Theme.blue} size={28} />}>
                        {trans("no_fie_queries_yet")}
                    </Message>
                }

                <CreatePredefinedQueries />
            </div>
        )
    }
}

const ButtonsGrid = css(Grid)({
    float: 'right',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    }
})

const EditActiveQueryDiv = css('div')({
    position: 'fixed',
    left: 'calc(50% - 250px)',
    background: '#ffffff',
    padding: '15px',
    borderRadius: '8px',
    zIndex: '999',
})

const StyledTable = css(TableGrid)({
    ' .clickable': {
        cursor: 'pointer',
    },
    ' .muk-cell': {
        display: 'block',
    },
})

function mapStateToProps(state) {
    return {
        activeFIEQueryId: state.activeFIEQueryId,
        fieQueries: state.fieQueries,
    }
}

export default connect(mapStateToProps, {
    initForm,
    setActiveFIEQueryId,
    setFIEQueriesToStore,
})(withRouter(FieQueries))